/**
 * Local LLM Adapter — INTERFACE ONLY. No runtime, no network.
 *
 * For Ollama / llama.cpp / LM Studio style local servers. Integration:
 * point `endpoint` at the local server (e.g. http://localhost:11434),
 * implement generate() against its OpenAI-compatible /v1/chat/completions
 * (most local runtimes expose one), and register the instance. Models
 * without native function calling can be prompted to emit JSON matching
 * prompt.functions[0].parameters — parseCreativeBriefCall() tolerates and
 * sanitizes imperfect output by design.
 */

import { AIProvider, NotImplementedError } from '../providerInterface';

export class LocalLLMAdapter extends AIProvider {
  constructor({ endpoint = null, model = 'llama3' } = {}) {
    super({
      id: 'local-llm',
      name: 'Local LLM (not connected)',
      capabilities: { functionCalling: false, streaming: true, offline: true },
    });
    this.endpoint = endpoint;
    this.model = model;
  }

  isReady() {
    return false;
  }

  async generate() {
    throw new NotImplementedError(
      'No local LLM is connected yet. Point LocalLLMAdapter at a local runtime (e.g. Ollama) and implement generate() — see README.md.'
    );
  }
}
